import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getOrders, GetOrdersApiParameter } from "@galarson/Handlers/BackOrderedItemsOrderService";
import BackOrderedItemsState, { backOrderedItemsTypes } from "@galarson/Store/BackOrderedItems/BackOrderedItemsState";

type HandlerType = ApiHandler<GetOrdersApiParameter, BackOrderedItemsState>;

export const DispatchBeginLoadOrders: any = (props:any) => {
    props.dispatch({
        type: "Data/BackOrdered/updateApiParameter",
        parameter: props.parameter,
    });
};

export const chain = [ DispatchBeginLoadOrders ];

const updateBackOrderedItemsApiParameter = createHandlerChainRunner(chain, "BackOrderedLoadOrderedUpdateApi");
export default updateBackOrderedItemsApiParameter;
